import React from 'react'

const Extra = () => {
  return (
    <div>
    <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Python list methods or Python list of functions</h1>
  
  
    <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Adding Elements to a List:</h1>
  
  
  
  
    <div className='text-[#9EB2D2] '>
                             
                             <p>
                        
                             This function uses to add an element at the end of the List. <br /> <br />
                             <span className='font-bold'>
  There are three methods for adding things to the python list: <br /><br />
  
  1, Python list append( ) <br />
  2, Python list extend( ) <br />
  3, Python list insert( ) <br />
  </span>
                             </p>
                            
                        </div>
  
  
  
  
  
  
  
                        <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>1. Python list append</h1>
  
  <div className='text-[#9EB2D2]'>
                           
                           <p>
                      
                           Python List append() method makes it easy to build lists dynamically.
                           </p>
                          
                      </div>
  
  
  
                      <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Q-Write a Program Python list append b with a Example?</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
        
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
           
                </p>
              </div>
  
  
  
  
  
  
              <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Q-I want to buy fruits use for Python list append?</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
               
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
    
                </p>
              </div>
  
  
  
  
  
              <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Q-Write a Program to input Five elements and store them into a list using for loop in Python list append?</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
              
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Input:</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
           
                </p>
              </div>
                          <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
               
                </p>
              </div>
  
  
  
  
  
  
              <div className='text-[#9EB2D2]'>
                             
                             <p>
                        
                             If you don't know about input in Python so check on Python input tutorial.
                             </p>
                            
                        </div>
  
  
  
                        <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Python list extend</h1>
  
                        <div className='text-[#9EB2D2]'>
                             
                             <p>
                        
                             Python list extend() use in python list extend for add multiple items to the ends of the list.
                             </p>
                            
                        </div>
  
  
  
  
  
  
                        <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Q-Python list extends the Example?</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
             
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
                
                </p>
              </div>
  
  
  
  
              <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Difference between Append vs Extend in Python Lists</h1>
              <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Q-Append vs Extend in Python Lists Example?</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
            
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
          
                </p>
              </div>
  
  
  
  
  
  
              <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Python list Insert():</h1>
  
  <div className='text-[#9EB2D2]'>
       
       <p>
  
       Python list Insert an element into another list at a specific position.
       </p>
      
  </div>
  
  
  
  
  
  <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Q-Python list insert() example?</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
        
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
      
                </p>
              </div>
  
  
  
  
  
              <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Python list update():</h1>
  
  <div className='text-[#9EB2D2]'>
       
       <p>
  
       the index used to change one of the list items
       </p>
      
  </div>
  
  
  
  
  <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Simple Python list example</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
         
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
        
                </p>
              </div>
  
  
  
  
              <p className='font-bold text-lg'>But After use Python list update:</p>
  
  
  
              <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Q-Use Python list update Example?</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
              
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
            
                </p>
              </div>
  
  
  
  
  
  
  
              <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Python list Slice() Example:</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
     
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
             
                </p>
              </div>
  
  
              <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Concatenating Two Lists in Python:</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
        
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
  
                </p>
              </div>
  
  
  
  
  
              <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Python Delete List:</h1>
  
  <div className='text-[#9EB2D2]'>
       
       <p>
      <b> Python Remove() List</b> <br />
  It Removes a particular item from the List.
       </p>
      
  </div>
  
  
  
  
  <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Q-Python Remove list Example?</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
              
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
         
                </p>
              </div>
  
  
  
  
  
  
  
              <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Python Delete list Example:</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
          
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
       
                </p>
              </div>
  
  
  
  
  
              <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Python Pop List</h1>
  
  <div className='text-[#9EB2D2]'>
       
       <p>
      <b> Python Pop() method inside the list: </b> <br />
  Removes the last component
       </p>
      
  </div>
  
  
  
  
  
  <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Q-Python Pop list Example?</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
               
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
                
                </p>
              </div>
  
  
  
  
              <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Python list clear() method:</h1>
  
  <div className='text-[#9EB2D2]'>
       
       <p>
  
       it removes all element
       </p>
      
  </div>
  
  
  
  
  
  <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Q-Python Clear list Example?</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
          
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
           
                </p>
              </div>
  
  
  
              <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Python List Index () Method:</h1>
  
  <div className='text-[#9EB2D2]'>
       
       <p>
  
       It returns the index no of the first Match.
       </p>
      
  </div>
  
  
  
  
  
  <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Q-Python list Index() Example?</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
              
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
         
                </p>
              </div>
  
  
  
  
  
  
  
  
              <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Python List Count:</h1>
  
  <div className='text-[#9EB2D2]'>
       
       <p>
      <b> Python count() method:</b> <br />
  Python List Count to count the no of items
       </p>
      
  </div>
  
  
  
  
  
  <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Q-Python list Count() Example?</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
         
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
        
                </p>
              </div>
  
  
  
              <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Python List sort:</h1>
  
              <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Q-Python list sort() Example?</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
             
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
        
                </p>
              </div>
  
  
  
  
  
              <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Python List Reverse():</h1>
  
  <div className='text-[#9EB2D2]'>
       
       <p>
  
      <b> Python List Reverse: </b> <br />
  The List can be reverse when sorted, also using reverse, but the reverse is true.
       </p>
      
  </div>
  
  
  
  
  
  <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Q-Python list reverse() Example?</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
              
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
              
                </p>
              </div>
  
  
              <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Q-Write a program to input five elements and add to a list print all elements in descending order?</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
            
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
             
                </p>
              </div>
  
  
  
  
  
  
  
  
  
  
  
              <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Python List range:</h1>
  
              <div className='bg-[#2c3e4c] p-3 rounded-t-xl'>
                  <div className=' flex gap-2 pl-7 items-center'>
                    <div className='sm:p-1.5  rounded-full bg-[#ff6056]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#ffbf21]'> </div>
                    <div className='sm:p-1.5  rounded-full bg-[#29c940]'> </div>
                    <div className='mx-1'>
                      <p className='text-lg font-semibold text-[#01B6FF]'>Q-Write a program to input five elements and add to a list print all elements in descending order?</p>
                    </div>
  
                  </div>
  </div>
  <div className='bg-[#1f3040] rounded-b-xl'>
    
  </div>
  
  
  <h1 className='text-[#01B6FF] my-4 sm:text-2xl text-xl font-semibold sm:font-normal '>Output :</h1>
  <div className='bg-[#2c3e4c] p-3 rounded-b-xl font-bold '>
                <p className='whitespace-pre-wrap '>
              
                </p>
              </div>
  
  
  
    </div>
  

  )
}

export default Extra
